import { IconType } from 'react-icons';

import { EditorLeftSideBarTab } from 'types';
import IconButton from 'components/ui/IconButton';
import CustomTooltip from 'components/CustomTooltip';

interface TabButtonProps {
  tooltip: string;
  tab: EditorLeftSideBarTab;
  selectedTab: EditorLeftSideBarTab;
  onTabClick: (newTab: EditorLeftSideBarTab) => void;
  Icon: IconType;
}

const TabButton = ({ tab, tooltip, selectedTab, Icon, onTabClick }: TabButtonProps) => {
  const className = `tab-button-${tooltip}`;
  return (
    <>
      <IconButton
        className={className}
        $isSelected={selectedTab === tab}
        $size={40}
        $iconSize={24}
        $hasRadius
        onClick={() => onTabClick(tab)}
      >
        <Icon />
      </IconButton>
      <CustomTooltip anchorSelect={`.${className}`} hasDelay>
        {tooltip}
      </CustomTooltip>
    </>
  );
};

export default TabButton;
